<template>
  <div class="loading-spinner">
    <font-awesome-icon
      icon="spinner"
      aria-hidden="true"
      class="loading-spinner__icon"
      :size="size"
      spin></font-awesome-icon>
    <div v-if="label"
         :style="{ 'font-size': fontSize }"
         class="loading-spinner__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    label: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },
  computed: {
    fontSize () {
      let result = "1rem";

      if ( this.size === "2x" ) {
        result = "1.4rem";
      }

      return result;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../Styles/utils/colors.less";

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;

  &__icon {
    margin-right: 10px;
  }
}
</style>
